export default function HCPLogistics() {
  return (
    <div>
      <h1>Logística HCP</h1>
      <p>Gerenciamento de logística do HCP.</p>
    </div>
  );
}
